import * as React from 'react';
import { useFeatureServices } from './use-feature-services';
import { Header } from './components/header/header';
import { TimelineGti } from './components/timelineGti/timelineGti';
import { GlobalStyle } from './styles/GlobalStyle';
import { GalleryGti50 } from './components/galleyGti50/galleryGti50';
import GalloReveal from './components/galloReveal/galloReveal';
import { DetailGti50 } from './components/deteailGti50/detailGti50';
import { ApuntateGti50 } from './components/apuntateGti50/apuntateGti50';
import { FormGti50 } from './components/formGti50/formGti50';
import { NbabGti50 } from './components/nbabGti50/nbabGti50';
import { TimelineGtiTitle } from './components/timelineGtiTitle/timelineGtiTitle';

export interface FaContentGTI {
  active_gti_form: string;
}

export function Home(): JSX.Element {
  const {
    'breadcrumb-service': breacrumbService,
    'page-info-service': pageInfoService,
    'fa-content-service': contentService,
  } = useFeatureServices();

  const faContentGTI = contentService?.content as FaContentGTI;

  React.useEffect(() => {
    breacrumbService.set([]);
    pageInfoService.setPageInfo();
  }, [pageInfoService, breacrumbService]);
  
  return (
    <>
      <GlobalStyle />
      {faContentGTI.active_gti_form == 'true' && <NbabGti50 />}
      <Header />
      <GalloReveal />
      <DetailGti50 />
      <GalleryGti50 />
      {false && <ApuntateGti50 />}
      {faContentGTI.active_gti_form == 'true' && <FormGti50 />}
      <TimelineGtiTitle />
      <TimelineGti />
    </>
  );
}
